import * as React from 'react';

import { AuthorizableTypeSelectorStyles } from '../styles/AuthorizableTypeSelectorStyle';
import { AuthorizableType, getAuthorizableTypeLabel } from '../types/AuthorizableType';

export const PERMISSIONS_TABS_TESTID = 'permissions-dialog-tabs';

export interface AuthorizableTypeSelectorProps {
  totalAuthorizableTypes: AuthorizableType[];
  onSelectAuthorizableType: (index: number) => void;
}

export type AuthorizableTypeSelectorState = {
  selectedIndex: number;
};

/**
 * The Permission Dialog for a "container" authorizable type (such as projects) allows users to set permissions for child authorizable types of that container.
 * This component is for selecting an authorizable type.
 *
 * Uses a priority-truncating tabs approach where all tabs are always visible, with inactive tabs truncating
 * their text to fit available space while the active tab displays its full label.
 */
export class AuthorizableTypeSelector extends React.Component<
  AuthorizableTypeSelectorProps,
  AuthorizableTypeSelectorState
> {
  constructor(props: AuthorizableTypeSelectorProps) {
    super(props);
    this.state = {
      selectedIndex: 0,
    };
  }

  private handleTabClick = (index: number): void => {
    this.setState({ selectedIndex: index });
    this.props.onSelectAuthorizableType(index);
  };

  public render() {
    return (
      <div className={AuthorizableTypeSelectorStyles.Container}>
        <div className={AuthorizableTypeSelectorStyles.TabsContainer} data-tb-test-id={PERMISSIONS_TABS_TESTID}>
          {this.props.totalAuthorizableTypes.map((authorizableType: AuthorizableType, index: number) => {
            const label = getAuthorizableTypeLabel(authorizableType);
            const isActive = this.state.selectedIndex === index;
            return (
              <button
                key={authorizableType}
                className={`${AuthorizableTypeSelectorStyles.Tab} ${isActive ? AuthorizableTypeSelectorStyles.ActiveTab : ''}`}
                onClick={() => this.handleTabClick(index)}
                title={label}
                role='tab'
                aria-selected={isActive}
                tabIndex={isActive ? 0 : -1}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}
